import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { useSettingsQueryApi } from 'graphql/generated';
import { formatDate, formatDateAndTime } from 'helpers/formaters/formatDate';

export const useFormatDate = (): {
    formatDate: typeof formatDate;
    formatDateAndTime: typeof formatDateAndTime;
} => {
    const { defaultTimezone } = useDomainConfig();
    const [{ data }] = useSettingsQueryApi({ requestPolicy: 'cache-only' });

    const timezone = data?.settings?.displayTimezone || defaultTimezone;

    return {
        formatDate: (date, format) => formatDate(date, timezone, format),
        formatDateAndTime: (date) => formatDateAndTime(date, timezone),
    };
};
